<template>

    <div>
        <a-table :columns="columns" :data-source="tablePurchaseOrders" :loading="tableLoading" :pagination="pagination"
            class="tableStyle">

            <!-- <template slot="thumb" slot-scope="">
                <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
            </template> -->
            <template slot="action" slot-scope="data">
                <a-dropdown>
                    <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                        <a-icon style="font-size:25px;" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <a @click="showMoreDetailsModal(data)">More Details</a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </template>
            <template slot="statusLabel" slot-scope='data'>
                <status-component :status="data"></status-component>
            </template>
        </a-table>

        <preview-waybill ref="previewRef"></preview-waybill>
        <waybill-download ref="downloasRef"></waybill-download>

        <!-- Receive Purchase Order Model -->
        <a-modal class="modalStyle" :visible="receiveOrderVisible" width="1000px" :footer="null"
            @cancel="handleReceiveOrderCancel">
            <a-spin :spinning="loading">
                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Receive Purchase Orders</h3>
                <receive-orders-form :data="data" @inventoryRequest="handleAddInventoryTransfer"></receive-orders-form>
            </a-spin>
        </a-modal>
    </div>

</template>
<script>

import moment from 'moment';
// import _ from 'lodash';
// import XLSX from "xlsx";
import { NotificationMixins }  from '@/mixins/NotificationMixins'
import PreviewWaybill from  '../../warehouse/common/PreviewWaybill.vue';
import WaybillDownload from  '../../warehouse/common/WaybillDownload.vue';
import { mapActions } from 'vuex';
// import ReceiveOrdersForm from '../modals/ReceiveOrdersForm.vue'

const columns = [
{
    title: "Date",
    // width: 150,
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: 'Shipment Order#',
    dataIndex: 'shipOrder',
    key: 'shipOrder'
    // width: 150,
  },
  {
    title: 'Customer Name',
    dataIndex: 'name',
    key: 'name'
    // width: 150,
  },
  {
    title: 'Sales Order #',
      dataIndex: 'sOrder',
      key: 'sOrder'
    
    // width: 150,
    },
    {
        title: 'Package #',
        dataIndex: 'package',
        key: 'package',
        // width: 150,
    },

    {
        title: 'Carrier #',
        dataIndex: 'carrier',
        key: 'carrier',
        // width: 150,
    },
    {
        title: 'Tracking #',
        dataIndex: 'tracking',
        key: 'tracking'
        // width: 150,
    },
    
  {
    title: 'Status',
    dataIndex: 'statusLabel',
    // width: 150,
    scopedSlots: { customRender: 'statusLabel' }
    },
    {
        title: 'Shipping Rate',
        dataIndex: 'shipRate',
        key: "shipRate"
        // width: 150,
    },
 
  {
    title: 'Action',
    dataIndex: 'action',
    // width: 150,
    scopedSlots: { customRender: 'action' }
  }
];

const tablePurchaseOrders = [
    {
        id: 1,
        key: 1,
        date: '14-03-2024',
        shipOrder: 'P-6568',
        name: 'Fuseini Ayambilla',
        sOrder: 'SO-35532',
        carrier: 'FedEx',
        package: 'PKG-5665',
        tracking: 'T-86568',
        statusLabel: 'Shipped',
        shipRate: 'Ksh 10',
        action: {
            id: 1,
        }
    },
    {
        id: 2,
        key: 2,
        date: '14-03-2024',
        shipOrder: 'P-6568',
        name: 'Fuseini Ayambilla',
        sOrder: 'SO-35532',
        carrier: 'FedEx',
        package: 'PKG-5665',
        tracking: 'T-86568',
        statusLabel: 'Shipped',
        shipRate: 'Ksh 10',
        action: {
            id: 2,
        }
    },
    {
        id: 3,
        key: 3,
        date: '14-03-2024',
        shipOrder: 'P-6568',
        name: 'Fuseini Ayambilla',
        sOrder: 'SO-35532',
        carrier: 'FedEx',
        package: 'PKG-5665',
        tracking: 'T-86568',
        statusLabel: 'Packed',
        shipRate: 'Ksh 10',
        action: {
            id: 3,
        }
    }
]


    import StatusComponent from '../../shared-components/StatusComponent.vue'
    export default {
        name:"AllShipmentTable",
        props:['purchaseOrdersData'],
        mixins: [ NotificationMixins ],
        components: {
            StatusComponent,
            PreviewWaybill,
            WaybillDownload
        },
        data(){
            return{
                tablePurchaseOrders, //this.purchaseOrdersData,
                tableLoading: false,
                receiveOrderVisible: false,
                loading: false,
                columns,
                data: {},
                pagination: {
                    pageSize:20
                }
            }
        },
        methods:{
            ...mapActions(['setPreviewInfo','addStockToWarehouse']),
            handleReceiveOrderCancel(){
                this.receiveOrderVisible = false
            },
            cancelPurchaseOrder(data){
                const request = {
                    status: 4,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            completedOrder(data){
                const request = {
                    status: 3,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            showMoreDetailsModal(data) {
                this.$router.push({ name: 'shipment-details', params: { id: data.id } }).catch(() => { });
            },
            markAsSend(data){
                const request = {
                    status: 1,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            showReceiveModal(data){
                this.data = data
                this.receiveOrderVisible = true
            },
            showMoreDetails(data){
                // console.log("data | ", data)
                const purchaseOrders = data.purchaseOrderLines.map(order => ({
                    key: order.id,
                    id: order.id,
                    productId: order.productId,
                    name: order.productName,
                    category: order.categoryName ? order.categoryName : "",
                    quantity: order.quantity.toString(),
                    unitPrice: order.price.toString(),
                    lineTotal: (parseInt(order.quantity) * parseFloat(order.price)).toFixed(2)
                }))
                let previewData = { 
                    discount: data.discount,
                    purchaseOrderId: data.id,
                    deliveryDate: moment(data.deliveryDate).format(),
                    supplierName: data.supplierName,
                    supplierId: data.supplierId,
                    supplierAddress: data.supplierAddress,
                    supplierCity: '',
                    supplierCountry: '',
                    destionation: '',
                    sellerAddress: data.sellerAddress,
                    shipCity: '',
                    shipCountry:'',
                    shippingMethodLabel: data.shippingMethodLabel,
                    shippingMethod: data.shippingMethod,
                    shippinTerm: data.terms,
                    tableData: purchaseOrders,
                    action: "edit",
                    statusLabel: data.statusLabel,
                    deleiveries: data.inventoryDeliveries
                }
                // console.log("previewData | ", previewData)
                this.setPreviewInfo(JSON.stringify(previewData)); 
                this.$router.push({
                    name: 'purchase-order-invoice'
                    }).catch(()=>{})
            },
            showCancelActions(data){
                const allowedStatus = ['Draft', 'Pending']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showReceiveActions(data){
                const allowedStatus = ['Receiving', 'Pending']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showCompletedActions(data){
                const allowedStatus = ['Receiving']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showMarkAsSendActions(data){
                const allowedStatus = ['Draft']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            async handleAddInventoryTransfer(data){
                this.loading = true;
                const response = await this.addStockToWarehouse(data);
                this.loading = false;
                if (response.status === 200) {
                    this.receiveOrderVisible = false
                    this.showSuccessAlert("Purchase Order Received Successfully");
                    this.$emit('orderData', true)  
                } else {
                    // // console.log("Error | ", response);
                    this.showErrorAlert(response.data.messages);
                }  
                 
            },

            showPreview(data){
                // console.log("data | ", data)
                const waybillInfo = {
                    requestId: data.requestId,
                    fulfillmentLines: data.fulfillmentLines.map(product => ({
                    productBrandName: product.productBrandName,
                    quantity: product.quantity,
                    productId: product.productId,
                    key: product.productId
                    })),
                    expectedAt: moment(data.expectedAt).format("DD-MMM-YYYY"),
                    destinationLocationName: data.request.destinationLocationName,
                    requestedBy: data.request.requestedBy,
                    sourceLocationName: data.request.sourceLocationName
                }
                this.$refs.previewRef.showPreviewData(waybillInfo);
            },
            showDownload(data){
                const waybillInfo = {
                    requestId: data.requestId,
                    fulfillmentLines: data.fulfillmentLines.map(product => ({
                    productBrandName: product.productBrandName,
                    quantity: product.quantity,
                    productId: product.productId,
                    key: product.productId
                    })),
                    expectedAt: moment(data.expectedAt).format("DD-MMM-YYYY"),
                    destinationLocationName: data.request.destinationLocationName,
                    requestedBy: data.request.requestedBy,
                    sourceLocationName: data.request.sourceLocationName
                }
                this.$refs.downloasRef.downloadWaybill(waybillInfo);
            },
        },
        computed:{
            
        },
        watch: { 
            purchaseOrdersData:{
                immediate: true, 
                handler () {
                    // this.tablePurchaseOrders = newValues
                }
                
            }    
        }
    }
</script>

<style  scoped>

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.customerTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>